import { Field } from "react-final-form";
import TextFieldAdapter from "@soqs/common/dist/Components/Adapters/TextFieldAdapter";

export interface EmailFieldProps {
  required: boolean;
  label: string;
  name: string;
  id?: string;
}

const EmailFieldComponent = (props: EmailFieldProps) => {
  let name = props.name;

  if (name === undefined) {
    name = "email";
  }

  const isValid = (email: string) => {
    if (
      !props.required &&
      (email === undefined || email === null || email === "")
    )
      return undefined;
    //RFC-5322 https://www.ietf.org/rfc/rfc5322.txt http://emailregex.com/
    const re = // eslint-disable-next-line no-control-regex
      /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
    const valid = re.test(email?.toLowerCase());
    if (valid) {
      const split = email.split("@");
      if (split[1].length < 5) return "Please enter a valid email address";
      return undefined;
    }
    return "Please enter a valid email address";
  };

  const stripSpaces = (value: string) => {
    return value ? value?.trim() : "";
  };

  return (
    <Field
      name={name}
      label={props.label ?? "Email"}
      validate={isValid}
      component={TextFieldAdapter}
      subscription={{
        touched: true,
        value: true,
        error: true,
      }}
      parse={stripSpaces}
      inputProps={{
        maxLength: 50,
      }}
      fullWidth={true}
      required={props.required}
      id={props.id ?? props.name}
    />
  );
};

export default EmailFieldComponent;
